import { fromJS } from "immutable";
import * as ReducerActions from "./actions";

const initialState = fromJS({
  data: {
    niveles: undefined,
    nivelEdit: undefined,
  },
});

export default function nivelesReducer(state = initialState, action) {
  if (action.type === ReducerActions.SET_NIVELES) {
    return state.setIn(["data", "niveles"], action.payload);
  }

  if (action.type === ReducerActions.SAVE_NIVEL) {
    return state.setIn(["data", "nivelEdit"], action.payload);
  }

  return state;
}
